import { useEffect, useState, type ReactNode } from 'react';
import { useNavigation } from 'react-router-dom';

export type NexusNavPhase = 'idle' | 'preload' | 'skeleton' | 'ready';

/**
 * Hook simplificado para loading de navegação com React Router.
 * Substituição do hook baseado em Inertia.js para SPA pura.
 */
export function useNexusNavigationLoading() {
    const navigation = useNavigation();
    const [phase, setPhase] = useState<NexusNavPhase>('idle');
    const [soft] = useState(false);
    
    // Skeleton padrão (pode ser customizado por rota depois)
    const pageSkeleton: ReactNode = null;

    useEffect(() => {
        if (navigation.state === 'loading') {
            setPhase('preload');
        } else if (navigation.state === 'idle') {
            setPhase('idle');
        }
    }, [navigation.state]);

    const showPreloader = phase !== 'idle';
    const showSkeleton = phase === 'skeleton';
    const showSpinner = phase === 'preload';
    const contentEntering = phase === 'ready';
    const contentDimmed = phase !== 'idle' && phase !== 'ready';

    return {
        soft,
        pageSkeleton,
        showSkeleton,
        showPreloader,
        showSpinner,
        contentEntering,
        contentDimmed,
    };
}
